import cacheKeys from '@debbie/common/dist/cache/keys.js';
import * as keysAPI from '../api/keys.js';
import q from '../query.js';
export const keysEntity = 'api-keys';
const keysKey = (creditorId) => `api-keys-${creditorId || ''}`;
export const useKeys = (creditorId) => q.query(keysKey(creditorId), () => keysAPI.getAll(creditorId), cacheKeys.read.collection(keysEntity));
const keyByIdKey = (id) => `api-key-${id}`;
export const useKeyById = (id) => q.query(keyByIdKey(id), () => keysAPI.getById(id), cacheKeys.read.item(keysEntity, id));
//# sourceMappingURL=index.js.map